import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
  useState,
  useCallback,
} from 'react';
import { styled } from '@material-ui/core/styles';
import { ExpandMore as DownArrowIcon } from '@material-ui/icons';
import { SdmFloatingActionButton } from '.';

let isLoadDisabled = false;
const btnSize = 40;

const ScrollContainer = styled('div')({
  height: '100%',
  '& > div::-webkit-scrollbar': {
    width: 6,
  },
  '& > div::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '& > div::-webkit-scrollbar-thumb': {
    background: 'rgba(149, 152, 154, 0.43)',
    borderRadius: 5,
  },
  '& > div::-webkit-scrollbar-thumb:hover': {
    background: 'rgba(149, 152, 154, 1)',
  },
});

const Scrollable = styled('div')({
  paddingRight: 4,
  marginRight: -4,
  height: '100%',
  overflow: 'auto',
});

/* eslint-disable */
export const SdmScrollable = forwardRef(
  (
    {
      children,
      containerStyle,
      style,
      loadMoreContentCallback,
      setHasScrolled = () => {},
      hideBtn = false,
      ...rest
    },
    ref
  ) => {
    useImperativeHandle(ref, () => ({
      scrollToBottom() {
        _scrollToBottom();
      },
      scrollToTop() {
        _scrollToTop();
      },
    }));

    const [isOnLoad, setIsOnLoad] = useState(false);
    const [isReturnVisible, setIsReturnVisible] = useState(false);
    const scrollRef = useRef();
    const loaderRef = useRef();
    const scrollContainerRef = useRef();

    const startLoad = useCallback(() => {
      if (!isLoadDisabled) {
        isLoadDisabled = true;
        setIsOnLoad(true);
      }
    }, [isLoadDisabled]);

    const scrollListener = async (event) => {
      const el = event.target;
      const visible = el.clientHeight; //527
      const totalHeight = el.scrollHeight;
      const actualPosition = el.scrollTop;

      if (totalHeight >= visible) {
        if (actualPosition <= totalHeight / 2) {
          startLoad();
        } else {
          isLoadDisabled = false;
        }
      }
      setIsReturnVisible(totalHeight - actualPosition > visible * 1.1);
      setHasScrolled(totalHeight - actualPosition > visible * 1.1);
    };

    useEffect(() => {
      if (isOnLoad) {
        handleLoadMoreContent();
      }
    }, [isOnLoad]);

    const _scrollTo = (position) => {
      scrollRef.current.scrollTop = position;
    };

    const _scrollToBottom = () => {
      _scrollTo(
        scrollRef.current.scrollHeight - scrollRef.current.clientHeight
      );
    };

    const _scrollToTop = () => {
      _scrollTo(0);
    };

    const handleLoaderClick = () => {
      loaderRef.current.click();
    };

    const handleLoadMoreContent = async () => {
      await loadMoreContentCallback();

      setIsOnLoad(false);
    };

    return (
      <ScrollContainer
        {...rest}
        style={{ ...containerStyle }}
        ref={scrollContainerRef}
      >
        <Scrollable
          style={{ ...style }}
          onScroll={loadMoreContentCallback && scrollListener}
          ref={scrollRef}
        >
          {children}
        </Scrollable>
        {scrollRef.current && !hideBtn ? (
          <SdmFloatingActionButton
            variant={'rounded'}
            onClick={() => _scrollToBottom()}
            size={btnSize}
            offset={scrollRef.current.clientWidth}
            position={'right'}
            isvisible={isReturnVisible ? 1 : 0}
          >
            <DownArrowIcon style={{ marginLeft: 1, marginTop: 4 }} />
          </SdmFloatingActionButton>
        ) : null}
      </ScrollContainer>
    );
  }
);
/* eslint-enable */
